var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.667,
    height: 20.533,
    viewBox: "0 0 18.667 20.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.989,23.529a10.161,10.161,0,0,0,9.8-7.577A10.325,10.325,0,0,0,18.121,4.4,9.943,9.943,0,0,0,13.875,3a.833.833,0,0,0-.794.415.856.856,0,0,0,0,.906,8.651,8.651,0,0,1,.362,9.172A8.422,8.422,0,0,1,5.4,17.722a.833.833,0,0,0-.794.415.856.856,0,0,0,0,.906,10.055,10.055,0,0,0,8.359,4.487Zm1.889-9.16a10.437,10.437,0,0,0,.51-9.313,8.248,8.248,0,0,1,1.9.847h0a8.643,8.643,0,0,1,2.564,11.445A8.411,8.411,0,0,1,8.734,20.668,8.369,8.369,0,0,1,7.062,19.4,10.179,10.179,0,0,0,14.878,14.369Z",
    transform: "translate(-4.475 -2.996)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.0343b14b335c3bcd79900e3a2f4f12b7.svg";
export { ForwardRef as ReactComponent };